import { Badge, Button, Center, Code, Collapse, Group, Paper, Stack, Text } from '@mantine/core';
import { useState } from 'react';

import { getStatusColor } from '../request-logger.utils';

import type { RequestLog } from '@admin/hooks';
interface ExternalCallsTabProps {
  externalCalls: RequestLog[];
}

export const ExternalCallsTab = ({ externalCalls }: ExternalCallsTabProps) => {
  const [expandedId, setExpandedId] = useState<string | null>(null);

  const toggleExpand = (id: string) => {
    setExpandedId(expandedId === id ? null : id);
  };

  if (externalCalls.length === 0) {
    return (
      <Center p="xl">
        <Text c="dimmed">No external calls were made during this request</Text>
      </Center>
    );
  }

  return (
    <Stack gap="xs">
      {externalCalls.map((call) => (
        <Paper key={call._id} withBorder p="md">
          <Group justify="space-between" mb="xs">
            <Group>
              <Badge size="sm">{call.request?.method}</Badge>
              <Text size="sm" style={{ fontFamily: 'monospace' }}>
                {call.destination}
              </Text>
            </Group>
            <Badge color={getStatusColor(call.response?.status)}>{call.response?.status}</Badge>
          </Group>

          <Collapse in={expandedId === call._id}>
            <Stack gap="md" mt="md">
              {call.request?.body && (
                <div>
                  <Text size="xs" c="dimmed" mb={4}>
                    Request Body:
                  </Text>
                  <Code block style={{ maxHeight: '200px', overflow: 'auto' }}>
                    {JSON.stringify(call.request.body, null, 2)}
                  </Code>
                </div>
              )}

              {call.response?.body && (
                <div>
                  <Text size="xs" c="dimmed" mb={4}>
                    Response Body:
                  </Text>
                  <Code block style={{ maxHeight: '200px', overflow: 'auto' }}>
                    {typeof call.response.body === 'string' ? call.response.body : JSON.stringify(call.response.body, null, 2)}
                  </Code>
                </div>
              )}
            </Stack>
          </Collapse>

          <Button variant="subtle" size="xs" onClick={() => toggleExpand(call._id)} mt="xs">
            {expandedId === call._id ? 'Hide' : 'Show'} Details
          </Button>
        </Paper>
      ))}
    </Stack>
  );
};
